/**
 * Generate demo assessment data for testing
 */

export const generateDemoAssessment = () => {
  const assessmentId = 'demo-student-001';
  const timestamp = new Date().toISOString();

  return {
    id: assessmentId,
    status: 'completed',
    createdAt: timestamp,
    completedAt: timestamp,
    updatedAt: timestamp,

    // Personal Information
    personalInfo: {
      schoolName: 'Delhi Public School',
      firstName: 'Aarav',
      lastName: 'Sharma',
      grade: '10',
      section: 'A',
      phone: '+91 98765 43210',
      email: 'aarav.sharma@example.com',
      age: 15,
      gender: 'Male',
      sport: 'Football',
      timestamp: timestamp
    },

    // Nutrition Assessment Responses (25 questions)
    nutritionResponses: [
      { questionId: 'n1', answer: 'n1_b', score: 2, category: 'energy_food_quality' },
      { questionId: 'n2', answer: 'n2_c', score: 3, category: 'protein_frequency' },
      { questionId: 'n3', answer: 'n3_c', score: 3, category: 'hydration_during_sport' },
      { questionId: 'n4', answer: 'n4_c', score: 3, category: 'post_workout_recovery' },
      { questionId: 'n5', answer: 'n5_b', score: 2, category: 'bone_health_foods' },
      { questionId: 'n6', answer: 'n6_c', score: 3, category: 'junk_food_frequency' },
      { questionId: 'n7', answer: 'n7_b', score: 2, category: 'sleep_quality' },
      { questionId: 'n8', answer: 'n8_b', score: 2, category: 'vitamins_minerals' },
      { questionId: 'n9', answer: 'n9_c', score: 3, category: 'vitamins_minerals' },
      { questionId: 'n10', answer: 'n10_c', score: 3, category: 'meal_timing' },
      { questionId: 'n11', answer: 'n11_c', score: 3, category: 'sugar_intake' },
      { questionId: 'n12', answer: 'n12_c', score: 3, category: 'fat_quality' },
      { questionId: 'n13', answer: 'n13_b', score: 2, category: 'fat_quality' },
      { questionId: 'n14', answer: 'n14_c', score: 3, category: 'hydration_overall' },
      { questionId: 'n15', answer: 'n15_c', score: 3, category: 'meal_timing' },
      { questionId: 'n16', answer: 'n16_c', score: 3, category: 'food_quality' },
      { questionId: 'n17', answer: 'n17_b', score: 2, category: 'supplementation' },
      { questionId: 'n18', answer: 'n18_c', score: 3, category: 'digestion' },
      { questionId: 'n19', answer: 'n19_b', score: 2, category: 'meal_planning' },
      { questionId: 'n20', answer: 'n20_b', score: 2, category: 'nutrition_knowledge' },
      { questionId: 'n21', answer: 'n21_b', score: 2, category: 'vitamins_minerals' },
      { questionId: 'n22', answer: 'n22_c', score: 3, category: 'pre_workout_nutrition' },
      { questionId: 'n23', answer: 'n23_c', score: 3, category: 'energy_levels' },
      { questionId: 'n24', answer: 'n24_c', score: 3, category: 'meal_frequency' },
      { questionId: 'n25', answer: 'n25_c', score: 3, category: 'hydration_minerals' }
    ],

    // Cognitive/Psychometric Assessment Responses (24 questions)
    cognitiveResponses: [
      { questionId: 'c1', answer: 'c1_a', score: 3, trait: 'methodical', category: 'competitive_mindset' },
      { questionId: 'c2', answer: 'c2_b', score: 3, trait: 'flexible', category: 'game_adaptability' },
      { questionId: 'c3', answer: 'c3_b', score: 3, trait: 'hands_on', category: 'learning_style' },
      { questionId: 'c4', answer: 'c4_a', score: 3, trait: 'analytical', category: 'learning_style' },
      { questionId: 'c5', answer: 'c5_b', score: 3, trait: 'focused', category: 'sensory_processing' },
      { questionId: 'c6', answer: 'c6_b', score: 2, trait: 'visual_neutral', category: 'sensory_processing' },
      { questionId: 'c7', answer: 'c7_c', score: 3, trait: 'sustained_attention', category: 'attention' },
      { questionId: 'c8', answer: 'c8_b', score: 3, trait: 'word_focused', category: 'communication_style' },
      { questionId: 'c9', answer: 'c9_b', score: 3, trait: 'active_participant', category: 'leadership_style' },
      { questionId: 'c10', answer: 'c10_b', score: 3, trait: 'controlled', category: 'satisfaction_source' },
      { questionId: 'c11', answer: 'c11_a', score: 3, trait: 'adventurous', category: 'openness' },
      { questionId: 'c12', answer: 'c12_a', score: 3, trait: 'structured', category: 'discipline_approach' },
      { questionId: 'c13', answer: 'c13_b', score: 3, trait: 'visual_empathy', category: 'coach_interaction_style' },
      { questionId: 'c14', answer: 'c14_c', score: 3, trait: 'inquisitive', category: 'coach_interaction_style' },
      { questionId: 'c15', answer: 'c15_a', score: 3, trait: 'empathetic', category: 'coach_interaction_style' },
      { questionId: 'c16', answer: 'c16_d', score: 3, trait: 'action_oriented', category: 'stress_response' },
      { questionId: 'c17', answer: 'c17_d', score: 3, trait: 'pressure_performer', category: 'stress_response' },
      { questionId: 'c18', answer: 'c18_b', score: 3, trait: 'resilient', category: 'stress_response' },
      { questionId: 'c19', answer: 'c19_a', score: 3, trait: 'persistent', category: 'resilience_driver' },
      { questionId: 'c20', answer: 'c20_c', score: 3, trait: 'conceptual_learner', category: 'learning_style' },
      { questionId: 'c21', answer: 'c21_a', score: 3, trait: 'growth_mindset', category: 'resilience_driver' },
      { questionId: 'c22', answer: 'c22_b', score: 3, trait: 'kinesthetic_learner', category: 'learning_style' },
      { questionId: 'c23', answer: 'c23_a', score: 3, trait: 'structured', category: 'work_style' },
      { questionId: 'c24', answer: 'c24_a', score: 3, trait: 'teaching_learner', category: 'learning_style' }
    ],

    // Physical Tests Results (4 out of 7 tests)
    physicalTests: [
      {
        testId: 'squat',
        testName: 'Squats',
        reps: 5,
        targetReps: 5,
        duration: 28,
        metrics: {
          kneeAngle: 165,
          hipHeight: 78,
          elapsedTime: 28
        },
        completedAt: timestamp
      },
      {
        testId: 'lunge',
        testName: 'Lunges',
        reps: 5,
        targetReps: 5,
        duration: 35,
        metrics: {
          frontKneeAngle: 108,
          backKneeAngle: 155,
          elapsedTime: 35
        },
        completedAt: timestamp
      },
      {
        testId: 'tpose',
        testName: 'T-Pose Balance',
        duration: 40,
        targetDuration: 40,
        metrics: {
          armAngle: 178,
          shoulderAlignment: 'Good ✓',
          legTouches: 2,
          elapsedTime: 40
        },
        completedAt: timestamp
      },
      {
        testId: 'pushup',
        testName: 'Push-ups',
        reps: 5,
        targetReps: 5,
        duration: 32,
        metrics: {
          elbowAngle: 168,
          bodyAlignment: 'Straight ✓',
          elapsedTime: 32
        },
        completedAt: timestamp
      },
      {
        testId: 'highknee',
        testName: 'High Knee March',
        reps: 10,
        targetReps: 10,
        duration: 28,
        metrics: {
          kneeHeight: 95,
          hipAngle: 88,
          elapsedTime: 28
        },
        completedAt: timestamp
      },
      {
        testId: 'plank',
        testName: 'Plank Hold',
        duration: 25,
        targetDuration: 20,
        metrics: {
          backAngle: 175,
          hipAlignment: 'Good ✓',
          elapsedTime: 25
        },
        completedAt: timestamp
      },
      {
        testId: 'forwardbend',
        testName: 'Forward Bend',
        reps: 5,
        targetReps: 5,
        duration: 30,
        metrics: {
          hipAngle: 65,
          kneeStraightness: 'Good ✓',
          reachDistance: 15,
          elapsedTime: 30
        },
        completedAt: timestamp
      }
    ],

    // Calculated Scores
    scores: {
      nutrition: {
        total: 65,
        maxScore: 75,
        percentage: 86.7,
        zone: 'Strong Foundation'
      },
      cognitive: {
        total: 70,
        maxScore: 72,
        percentage: 97.2,
        zone: 'Excellent'
      },
      physical: {
        testsCompleted: 7,
        averageFormScore: 88,
        zone: 'Excellent Performance'
      }
    }
  };
};

// Function to load demo data into localStorage
export const loadDemoData = () => {
  const demoAssessment = generateDemoAssessment();
  const existingData = localStorage.getItem('health_assessments');
  const assessments = existingData ? JSON.parse(existingData) : {};
  
  assessments[demoAssessment.id] = demoAssessment;
  localStorage.setItem('health_assessments', JSON.stringify(assessments));
  
  console.log('✅ Demo data loaded successfully!');
  console.log('Demo Student:', demoAssessment.personalInfo);
  console.log('Assessment ID:', demoAssessment.id);
  
  return demoAssessment;
};

// Function to clear demo data
export const clearDemoData = () => {
  const existingData = localStorage.getItem('health_assessments');
  if (existingData) {
    const assessments = JSON.parse(existingData);
    delete assessments['demo-student-001'];
    localStorage.setItem('health_assessments', JSON.stringify(assessments));
    console.log('✅ Demo data cleared!');
  }
};
